﻿import QuerystringHelpers from '../helpers/QuerystringHelpers.js';

//optional features:
//1. update url after ajax call
//2. add ajax call for pagination
//3. remember open/closed state of filters for reload via paging

class Filter {
    constructor(elm) {
        this.elm = elm;
        this.$elm = $(elm);

        this.queryStringHelpers = new QuerystringHelpers();

        this.setEventListeners();
    }

    setEventListeners() {
        this.$elm.find('.filter-field').on('change', this.onChange.bind(this));
    }

    submit($form) {
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: response => {
                $('.searchResults-replace').html($(response).find('.searchResults-replace').html());
            }
        });
    }

    onChange(event) {
        var $target = $(event.target);

        var timeout = ($target.attr('type') === 'checkbox') ? 200 : 0;
        this.currentForm = $target.closest('form');

        setTimeout(() => {
            this.submit(this.currentForm);
        }, timeout);

		
    }
}

export default Filter;